// Attention: Now not use this for SSR

// Functional
import makeStyles from "@mui/styles/makeStyles";

// Elements
import GlobalStyles from "@mui/material/GlobalStyles";

// Lab

// Icons

export {
    // Functional
    makeStyles,

    // Elements
    GlobalStyles,

    // Lab

    // Icons
};
